class CardMediaCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;

    this.scroller = this.querySelector('[data-media-scroller]');
    if (!this.scroller) return;

    this.slides = Array.from(this.querySelectorAll('[data-media-slide]'));
    if (this.slides.length < 2) return;

    this.initialised = true;
    this.index = 0;
    this.ticking = false;
    this.handleScroll = this.handleScroll.bind(this);

    this.renderControls();
    this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  disconnectedCallback() {
    if (this.scroller && this.handleScroll) {
      this.scroller.removeEventListener('scroll', this.handleScroll);
    }
  }

  renderControls() {
    this.dots = document.createElement('div');
    this.dots.className = 'product-item__media-dots';
    this.dots.setAttribute('aria-hidden', 'true');

    this.slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.className = 'product-item__media-dot';
      if (index === 0) dot.classList.add('is-active');
      this.dots.appendChild(dot);
    });

    this.appendChild(this.dots);

    this.arrows = ['prev', 'next'].map((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `product-item__media-arrow product-item__media-arrow--${direction}`;
      button.setAttribute(
        'aria-label',
        direction === 'next'
          ? this.dataset.labelNext || 'Next image'
          : this.dataset.labelPrev || 'Previous image'
      );
      button.innerHTML =
        direction === 'next'
          ? '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M6.5 1L1.5 6L6.5 11" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.goTo(this.index + (direction === 'next' ? 1 : -1));
      });
      this.appendChild(button);
      return button;
    });

    this.updateArrows();
  }

  goTo(target) {
    const index = Math.min(Math.max(target, 0), this.slides.length - 1);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.scroller.scrollTo({
      left: index * this.scroller.clientWidth,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }

  handleScroll() {
    if (this.ticking) return;
    this.ticking = true;

    window.requestAnimationFrame(() => {
      const width = this.scroller.clientWidth;
      const next = width > 0 ? Math.round(this.scroller.scrollLeft / width) : 0;

      if (next !== this.index && this.dots.children[next]) {
        this.dots.children[this.index].classList.remove('is-active');
        this.dots.children[next].classList.add('is-active');
        this.index = next;
        this.updateArrows();
      }

      this.ticking = false;
    });
  }

  updateArrows() {
    if (!this.arrows) return;
    this.arrows[0].disabled = this.index === 0;
    this.arrows[1].disabled = this.index === this.slides.length - 1;
  }
}

if (!customElements.get('card-media-carousel')) {
  customElements.define('card-media-carousel', CardMediaCarousel);
}